module.exports = __webpack_public_path__ + "img/recruit_header.6b608115.png";